import React, { useEffect, useMemo, useRef, useState } from 'react';
import AdminLayout from '../../components/layout/admin';
import { Box, ComboboxData, Grid, Group, Space, Stack } from '@mantine/core';
import Card from '../../components/elements/Card';
import { useQuery } from '@tanstack/react-query';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import './style.scss'
import { Button } from '@mantine/core';
import { Row, Col, FormGroup, Label, Badge , Input, Container} from "reactstrap";
import Select from 'react-select';
import {DatePickerInput, DateTimePicker } from '@mantine/dates';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import {
    getDelegationUnit,
    getEmployee,
    getTaskDelegation,
    getTaskDelegationAdmin,
    getTaskType,
    saveTaskDelegation
  } from '../../services/taskDelegation';
import { useMutation } from '@tanstack/react-query';
import moment from 'moment';
import { edit } from 'ace-builds';
import { showNotification } from '../../utilities/mantineNotification';





const NewTaskDelegationAdmin = (props) => {

    const binusianId = props.auth.binusianId

    
    //TaskType
    const [taskType, setTaskType] = useState({category: '', code: '0', description1: ''})
    const [type, setType] = useState<ComboboxData>([]);
    const [selectedTaskType, setSelectedTaskType] = useState<any>('')

    //Unit
    const [selectedunitName, setSelectedUnitName] = useState<any>("")
    const [unit, setUnit] = useState<ComboboxData>([]) 
    const [unitType, setUnitType] = useState({kodeDep: '', NamaDep: ""})

    //Employee
    const [selectedpeopleName, setSelectedPeopleName] = useState('')
    const [selectedemployeeName, setSelectedEmployeeName] = useState('')
    const [employee, setEmployee] = useState({id: '', name: "", email: "", position: ""})
    const [employees, setEmployees] = useState([])
    const [employees2, setEmployees2] = useState([])
    const prevSelectedPeople = useRef('')
    const prevSelectedEmployee = useRef('')

    const [filteredQuery, setFilteredQuery] = useState([])
    const [filteredQuery2, setFilteredQuery2] = useState([])
    const [position, setPosition] = useState('')
    const [employeeposition, setEmployeePosition] = useState('')

    //Dates
    const [startDateTime, setStartDateTime] = useState(new Date());
    const [endDateTime, setEndDateTime] = useState(new Date());

    const [employeeId, setEmployeeId] = useState('')
    const [employeeId2, setEmployeeId2] = useState('')
    const [employeeName, setEmployeeName] = useState('')
    const [employeeName2, setEmployeeName2] = useState('')
    const [employeeEmail, setEmployeeEmail] = useState('')
    const [employeeEmail2, setEmployeeEmail2] = useState('')

    const [modalDialog, setModalDialog] = useState({ 
        opened: false,
        data: null
    });
    const [nameflag, setNameFlag] = useState(false)
    const [nameflag2, setNameFlag2] = useState(false)
    const [requestBody, setRequestBody] = useState({ BinusianID: binusianId , keyword: ''});

    const [binusianName, setBinusianName] = useState('test')

    const fetchMasterTask = useQuery({
        queryKey: ['getTaskDelegationAdmin'],
        queryFn:  () =>
            getTaskDelegationAdmin({
                BinusianID : binusianId,
                page: 1,
                take: 10
            })
    }) 

    //FetchType
    const fetchTaskType = useQuery({
     queryKey: ['getTaskType'],
     queryFn: () =>
       getTaskType()
       .then((resp) => {
         const data = resp.data.data.map(item =>({
           category : item.category,
           code: item.code,
           description1 : item.description1
         }))
         setType(data)
       })
  
    });
    
    useEffect(() => {
      if (taskType?.code || taskType?.code || taskType?.description1) {
          fetchTaskType.refetch;
        }
    }, [taskType, fetchTaskType]);
    
    const optionsTaskType = type.map(item => ({
      value: item.code,
      label: item.description1
    }));


    //FetchUnit
    const fetchUnitDel = useQuery({
        queryKey: ['getDelegationUnit', requestBody],
        queryFn: () =>
        getDelegationUnit(requestBody)
        .then((resp) => {
            // console.log('API Response:', resp);
            if (resp.data) {
                const _data = resp.data.data.map(item => ({
                    kodeDep: item.kodeDep,
                    NamaDep: item.namaDep 
                }));
                // console.log('Mapped Data:', data);
                setUnit(_data);
                setSelectedUnitName({label:_data[0].NamaDep, value: _data[0].kodeDep})
            } else {
                console.error('Invalid response format:', resp);
            }
        })
    })

    // useEffect(() => {
    // //   console.log(unit)  
    // if(requestBody.BinusianID || unitType?.NamaDep || unitType?.kodeDep){
    //     fetchUnitDel.refetch;
    // }
    // }, [requestBody.BinusianID, fetchUnitDel])

    // const optionsUnitType = unit.map(item => ({
    //     value: item.kodeDep,
    //     label: item.NamaDep
    // }))


    //FetchEmployee
    const fetchEmployee = useQuery({
        queryKey: ['getEmployee'],
        queryFn: () => 
            getEmployee({BinusianID : binusianId , keyword : selectedpeopleName})
        .then((resp) => {
            console.log(resp.data)
            const data = resp.data.data.map(item => ({
                id : item.binusianId,
                name : item.name,
                email : item.email,
                position : item.position
            }))
            setEmployees(data)
            console.log("employees")
            console.log(data)
        })
    })

    useEffect(() => {
        if (selectedpeopleName && prevSelectedPeople.current !== selectedpeopleName) {
            fetchEmployee.refetch();
            prevSelectedPeople.current = selectedpeopleName;
        }
    }, [selectedpeopleName, fetchEmployee]);

      //FetchEmployee
      const fetchEmployee2 = useQuery({
        queryKey: ['getEmployee'],
        queryFn: () => 
            // getEmployee({BinusianID : binusianIdTesting , keyword : selectedpeopleName})
            getEmployee({BinusianID : binusianId , keyword : selectedemployeeName})
        .then((resp) => {
            console.log(resp.data)
            console.log("fetch employee")
            const _data = resp.data.data.map(item => ({
                id : item.binusianId,
                name : item.name,
                email : item.email,
                position : item.position
            }))
            setEmployees2(_data)
            // if(employeeFlag){
            //     setEmployees(_data)
            //     // console.log(_data)
            //     if(_data[0].position){
            //         setPosition(_data[0].position)
            //     }
            // }
            // console.log("employees")
            
        })
    })
    useEffect(() => {
        if (selectedemployeeName && prevSelectedEmployee.current !== selectedemployeeName) {
            fetchEmployee2.refetch();
            prevSelectedEmployee.current = selectedemployeeName;
        }
    }, [selectedemployeeName, fetchEmployee2]);

    
    //save task
    const addTask = useMutation({
        mutationFn: saveTaskDelegation,
        onSuccess: (response) => {
            const parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;
           if(response.status == 2) {
            handleCloseModal();
             showNotification({
                type: 'error',
                message: parsedResponse.message
             });
           } else {
               fetchMasterTask.refetch();
               console.log("SUCCESSss");
               location.href = '/task-delegation-admin'
           }
        },
        onError: (error) => {
            console.log("ERRORrr");
            showNotification({
                type: 'error',
                message: JSON.stringify(error)
            })
        }
      });
  
    




    const handleTaskSelect = (selected) =>{
        setSelectedTaskType(selected);

    }

    const unitoption = unit.map(item => ({
        value: item.kodeDep,
        label: item.NamaDep
    }))


    const handleUnitSelect = (selected) =>{
        // console.log("unit")
        // console.log(selected)
        setSelectedUnitName(selected);
    }




    const handleSubmitData = (data) => {
        setModalDialog({
            opened: true,
            data: null
        });

    };


    const handleSave = () => {
        const localDateSt = new Date(startDateTime);
        const localDateEn = new Date(endDateTime);
        const sDate = new Date(localDateSt.getTime() - localDateSt.getTimezoneOffset() * 60000).toISOString();
        const eDate = new Date(localDateEn.getTime() - localDateEn.getTimezoneOffset() * 60000).toISOString();
        const data = {
            RequestorBinusianId: employeeId2,
            RequestorBinusianName: employeeName2,
            Email: employeeEmail2,
            EmailDelegate: employeeEmail,
            TaskDelegated: selectedTaskType.label,
            TaskCode: selectedTaskType.value,
            UnitDelegatedId: selectedunitName.value,
            UnitDelegatedName: selectedunitName.label,
            DelegatedBinusianId: employeeId,
            DelegatedBinusianName: selectedpeopleName,
            StartDate: sDate,
            EndDate: eDate,
            UserIn: binusianId,
            CreatedName: props.auth.fullName,
            CreatedEmail: props.auth.email
        }
       console.log(data)
        try {
            addTask.mutate(data)

        } catch (error) {
            console.error('Error saving task delegation:', error);
        }
    }

    const handleCloseModal = () => {
        setModalDialog({
        opened: false,
        data: null
        });
    };



      const handleSearchPeople = (query) =>{
        // console.log(employees)
        if(query == ''){
            setSelectedPeopleName('')
            setFilteredQuery([])
            setNameFlag(false)
            return
        }
        setSelectedPeopleName(query)
        if(query && employees){
            setFilteredQuery(employees);
            setNameFlag(true)
            }
        
        return
    }
      const handleSearchEmployee = (query) =>{
        // console.log(employees)
        if(query == ''){
            setSelectedEmployeeName('')
            setFilteredQuery2([])
            setNameFlag2(false)
            return
        }
        setSelectedEmployeeName(query)
        if(query && employees2){
            setFilteredQuery2(employees2);
            setNameFlag2(true)
            }
        
        return
    }
    
    const handleKeyDownSearch = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearchPeople(selectedpeopleName);
            employees.map((item, index) => (
                handlePeopleBio(item.email, item.name, item.position, item.id)
            )
            )
        }
      }

    


    const handlePeopleBio = (email, name, pos, id) =>{
        setPosition(pos)
        setSelectedPeopleName(name)
        setNameFlag(false)
        setEmployeeId(id)
        setEmployeeName(name)
        setEmployeeEmail(email)
    }
    const handleEmployeeBio = (email, name, pos, id) =>{
        setRequestBody({keyword: name, BinusianID:binusianId})
        setEmployeePosition(pos)
        setSelectedEmployeeName(name)
        setNameFlag2(false)
        setEmployeeId2(id)
        setEmployeeName2(name)
        setEmployeeEmail2(email)
        fetchUnitDel.refetch()

    }
  
    const formatDate = (value) => {
        if (!value || value == '') return '';
        return moment(value).format();
      }

      const handleInputStartDate = (date) => {
        setStartDateTime(date);
        return;
    }

    
    const handleInputEndDate = (date) => {
        setEndDateTime(date);
        return;
    }

    return(
        <>
        <AdminLayout>
            <Breadcrumbs
            pageTitle='Add New Task Delegation'
            itemList={[
                {
                    title : '',
                    href: '/new-task-delegation'
                }
                
            ]}
            />
            <Card>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Select Task</p>
                    <FormGroup>
                            <Select
                            name="Select Task"
                            placeholder = "Select Task"
                            value={selectedTaskType}
                            onChange={handleTaskSelect}
                            options={optionsTaskType}
                            menuPortalTarget={document.body}
                            menuShouldScrollIntoView = {false}
                            maxMenuHeight={230}
                            />
                           
                    </FormGroup>
                </div>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Employee Name</p>
                    <FormGroup>
                        <Input
                        name="people"
                        placeholder='Select Employee'
                        value={selectedemployeeName}
                        onChange={(e) => (handleSearchEmployee(e.target.value))}
                        onKeyDown={handleKeyDownSearch}
                        type='text'
                        />
                        {nameflag2 &&
                        <ul
                        style={{
                            listStyleType: 'none',
                            paddingLeft: 0,
                            position: 'absolute',
                            zIndex: 1000,
                            backgroundColor: 'white',
                            border: '1px solid #ccc',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            width: '100%'
                        }}>
                            {employees2.map((item, index) => (
                                <li key={index}
                                onClick={() => handleEmployeeBio(item.email, item.name, item.position, item.id)}>
                                {item.name}
                            </li>
                            ))}
                        </ul>
                        }
                    </FormGroup>
                </div>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Delegation Unit</p>
                    <FormGroup>
                            <Select
                            name="DelegationUnit"
                            placeholder = "Select Unit"
                            value={selectedunitName}
                            options={unitoption}
                            onChange={handleUnitSelect}
                            menuPortalTarget={document.body}
                            menuShouldScrollIntoView = {false}
                            maxMenuHeight={230}
                            />
                    </FormGroup>
                </div>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Delegated Employee Name</p>
                    <FormGroup>
                        <Input
                        name="people"
                        placeholder='Select People'
                        value={selectedpeopleName}
                        onChange={(e) => (handleSearchPeople(e.target.value))}
                        onKeyDown={handleKeyDownSearch}
                        type='text'
                        />
                        {nameflag &&
                        <ul
                        style={{
                            listStyleType: 'none',
                            paddingLeft: 0,
                            position: 'absolute',
                            zIndex: 1000,
                            backgroundColor: 'white',
                            border: '1px solid #ccc',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            width: '100%'
                        }}>
                            {employees.map((item, index) => (
                                <li key={index}
                                onClick={() => handlePeopleBio(item.email, item.name, item.position, item.id)}>
                                {item.name}
                            </li>
                            ))}
                        </ul>
                        }
                    </FormGroup>
                </div>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Position of Delegated Employee</p>
                    <FormGroup>
                        <Input
                        name="position"
                        value={position}
                        placeholder="Position"
                        disabled={true}
                        type="text"
                        />
                    </FormGroup>
                </div>
                <Container fluid="sm" style={{marginLeft: 0, paddingLeft: 0}}>
                <Row>
                    <Col style={{marginRight: 0}}>
                        <div className='select-wrapper'>
                        <p className="font-weight-bold">Start Date</p>
                        <FormGroup>
                                <DateTimePicker
                                clearable
                                value={startDateTime}
                                label="Pick date and time"
                                placeholder="Pick date and time"
                                onChange={handleInputStartDate}
                                size="md"
                                style={{width: '200px'}}
                                />      
                        </FormGroup>
                        </div>
                    </Col>
                    <Col>
                        <div className='select-wrapper'>
                        <p className="font-weight-bold">End Date</p>
                        <FormGroup>
                                <DateTimePicker
                                clearable
                                value={endDateTime}
                                label="Pick date and time"
                                placeholder="Pick date and time"
                                onChange={handleInputEndDate}
                                size="md"
                                style={{width: '200px'}}
                                />      
                                </FormGroup>
                        </div>
                    </Col>
                </Row>
                </Container>
                <Row className='submit-button-div'>
                    <Button color='purple' onClick={handleSubmitData}>
                        Submit
                    </Button>
                </Row>
            </Card>
        </AdminLayout>

        <ModalConfirmation
        isVisible = {modalDialog.opened}
        type='submit'
        onCancel={handleCloseModal}
        onConfirm={handleSave}
        />
         </>
        
    );
};

export default NewTaskDelegationAdmin;